import React from 'react';

const DropdownChevron = ({ title = 'Dropdown Icon - Open', description = 'Open Dropdown Icon', ...props }) => {
    return (
        <svg
            width="19"
            height="12"
            viewBox="0 0 19 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby="title desc"
            role="img"
            {...props}
        >
            <title id="title">{title}</title>
            <desc id="desc">{description}</desc>
            <path
                d="M9.5174 9.51896L9.51744 9.51893L16.8487 2.18459C17.1525 1.88071 17.1525 1.38492 16.8487 1.08104C16.5448 0.777155 16.049 0.777155 15.7451 1.08104L8.96562 7.86051L2.08303 0.977911C1.77915 0.67403 1.28335 0.67403 0.979473 0.977911C0.828227 1.12916 0.75 1.33079 0.75 1.5297C0.75 1.72981 0.823799 1.92891 0.979473 2.08459L8.41385 9.51896C8.71773 9.82284 9.21352 9.82284 9.5174 9.51896Z"
                fill="#0A559D"
                stroke="#0A559D"
                stroke-width="0.5"
            />
        </svg>
    );
};

export default DropdownChevron;
